// holds conversations
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { InputAdornment, TextField, useTheme } from "@mui/material";
import { Plus, Search } from "lucide-react";
import { PlaygroundConversations } from "./playground-conversations";
import { cn } from "@/utils/cn";
import { muiColors } from "@/theme/designSystem";
import { useQueryState } from "nuqs";
import { useHref, useLocation, useNavigate } from "react-router-dom";
import { useSidebarStore } from "@/atoms/playground";
import { useStoredTheme } from "@/utils/theme-context";
import { useTranslation } from "react-i18next";

export const PlaygroundSidebar = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [search, setSearch] = useQueryState("q", { defaultValue: "" });
  const sidebarState = useSidebarStore();
  const navigate = useNavigate();
  const location = useLocation();
  const storedTheme = useStoredTheme();
  const theme = useTheme();

  return (
    <div
      className={cn(
        "transition-all duration-300 max-h-screen flex flex-col shrink-0",
        {
          "w-[220px] sm:w-[260px] md:w-[280px] p-2": sidebarState.isOpen,
          "w-0 p-0 overflow-hidden": !sidebarState.isOpen,
        },
      )}
    >
      <div
        style={{
          padding: "16px 0",
        }}
        className="flex justify-between items-center"
      >
        <h2 className="text-[16px] font-bold">
          {t("conversation.conversations")}
        </h2>
        <div className="flex items-center gap-2">
          <div
            onClick={() => navigate("/" + location.pathname.split("/")[1])}
            className="w-[48px] h-[34px] flex items-center justify-center rounded-xl bg-[var(--bg)] hover:bg-[var(--hover-bg)] cursor-pointer"
            style={
              {
                "--bg":
                  storedTheme.button.primary.backgroundColor[
                    theme.palette.mode
                  ],
                "--hover-bg":
                  storedTheme.button.primary.hoverBackgroundColor[
                    theme.palette.mode
                  ],
              } as React.CSSProperties
            }
          >
            <Plus
              color={storedTheme.button.primary.textColor[theme.palette.mode]}
            />
          </div>
          <button
            aria-label={
              sidebarState.isOpen
                ? t("playground.closeSidebar")
                : t("playground.openSidebar")
            }
            onClick={sidebarState.toggle}
            type="button"
            className="w-[34px] h-[34px] flex items-center justify-center p-1 cursor-pointer rounded-full bg-[var(--bg)] hover:bg-[var(--hover-bg)]"
            style={
              {
                "--bg":
                  storedTheme.button.primary.backgroundColor[
                    theme.palette.mode
                  ],
                "--hover-bg":
                  storedTheme.button.primary.hoverBackgroundColor[
                    theme.palette.mode
                  ],
              } as React.CSSProperties
            }
          >
            {isRTL ? (
              <ArrowRightIcon
                sx={{
                  fontSize: "20px",
                  color:
                    storedTheme.button.primary.textColor[theme.palette.mode],
                }}
                className={cn("transition-transform", {
                  "rotate-180": !sidebarState.isOpen,
                })}
              />
            ) : (
              <ArrowLeftIcon
                sx={{
                  fontSize: "20px",
                  color:
                    storedTheme.button.primary.textColor[theme.palette.mode],
                }}
                className={cn("transition-transform", {
                  "rotate-180": !sidebarState.isOpen,
                })}
              />
            )}
          </button>
        </div>
      </div>
      {sidebarState.isOpen && (
        <>
          {/*<TextField
            variant="outlined"
            placeholder={t("playground.searchPlaceholder")}
            onChange={(e) => setSearch(e.target.value)}
            value={search}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search className="text-2xl text-[var(--color-31)]" />
                </InputAdornment>
              ),
            }}
            sx={{
              height: "56px",
              width: "100%",
              "& .MuiOutlinedInput-root": {
                height: "56px",

                borderRadius: "4px",
                background: "none",
                "& fieldset": {
                  borderColor: "var(--color-78)",
                },
                "&:hover fieldset": {
                  borderColor: "var(--color-78)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "var(--color-78)",
                  borderWidth: "1px",
                },
              },
              "& .MuiInputBase-input": {
                fontWeight: "400",
                letterSpacing: "0.05em",
                padding: "16.5px 14px 16.5px 8px",
              },
            }}
          />*/}
          <div
            style={{
              scrollbarColor: `${muiColors.background.defaultDark} transparent`,
            }}
            className="flex-1 overflow-y-auto pr-1 rtl:pr-0 rtl:pl-1"
          >
            <PlaygroundConversations search={search} />
          </div>
        </>
      )}
    </div>
  );
};
